import { Title as CardTitle } from 'src/components/Card/Title';
import { Tag as SigningCaseTag } from 'src/components/Tag';
import styled from 'styled-components';
import { ISigningCaseDetailsHeader } from '../SigningCaseHeader/interfaces';
import { getMvpAppSigningCaseHeaderColor } from 'src/utils/getSigningCaseHeaderColor';

export const getHeaderColor = (props: ISigningCaseDetailsHeader) =>
  getMvpAppSigningCaseHeaderColor(props.status);

export const SigningCaseBorder = styled.div`
  margin-bottom: 12px;
`;

export const Tag = styled(SigningCaseTag)`
  position: absolute;
  margin-top: -48px;
  right: 0;
  font-family: 'Danske', 'Tahoma', Sans-Serif, sans-serif;
  padding: 4px 10px;
  color: ${getHeaderColor};
  border-radius: 6px;
`;

export const HeaderContainer = styled.div`
  margin-top: 200px;
  position: relative;
  font-family: 'Danske', 'Tahoma', Sans-Serif, sans-serif;
  width: 100%;
`;

export const TitleContainer = styled.div`
  display: inline-block;
  width: 90%;
`;

export const SigningCaseTitle = styled(CardTitle)`
  padding: 0;
  font-family: 'DanskeRegularNew', 'Tahoma', Sans-Serif, sans-serif;
  font-size: 22px;
  font-weight: 500;
  text-align: left;
`;
